import { PartialType } from '../../../utils';
import { CreateVisibilityMapDto } from './create-visibility-map.dto';
export class UpdateVisibilityMapDto extends PartialType(CreateVisibilityMapDto) {
}
